import get from 'get-value';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage, injectIntl } from 'react-intl';
import 'react-picky/dist/picky.css';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { clearAlerts } from '../../../actions/alertsActions';
import {
    lockAseInternalTicket,
    resetRedirectAfterAseInternalLockTicket
} from '../../../actions/ase/actionAseInternalLockTicket';
import { updateAseUserInternalTicketListPreference } from '../../../actions/ase/actionAsePreferences';
import {
    allIssueOrigins,
    documentationUpdate,
    domains,
    getInternalTicketFormStates,
    issueIdentifiedMessages,
    priorityTreatment,
} from '../../../constants/Utils';
import { ASE_INTERNAL_MAINTENANCE_TICKET_FORM, ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM, ASE_INTERNAL_TICKET_FORM } from '../../../constants/formConstants';
import issueIdentifiedIntlMessages from '../../../intl/afterSales/issueIdentifiedMessages';
import issueOriginMessages from '../../../intl/afterSales/issueOriginMessages';
import listMessages from '../../../intl/afterSales/listMessages';
import priorityTreatmentMessages from '../../../intl/afterSales/priorityTreatmentMessages';
import commonMessages from '../../../intl/common/commonMessages';
import formStatesMessages from '../../../intl/common/formStatesMessages';
import { ASE_INTERNAL_MAINTENANCE_TICKET, ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET, ASE_INTERNAL_TICKET } from '../../../routes/paths';
import { formatTicketNumber } from '../../../utils/utils';
import Loader from '../../Loader';
import PageHeader from '../../common/PageHeader';
import { StyledPicky } from '../../common/StyledComponents';
import DatePickerTableComponent from '../../common/datePicker/DatePickerTableComponent';
import checkRoles from '../../common/roleChecker/RoleChecker';
import ListAseInternalTicketTable from './ListAseInternalTicketTable';

const domain = domains.ASE;

class ListAseInternalTicketPage extends Component {
    constructor(props) {
        super(props);
        const { intl } = props;

        this.state = {
            ratchet: false,
            columnLibrary: [
                {
                    id: 'ORDER_CREATION_TIME',
                    accessor: 'created',
                    message: listMessages.TABLE_IT_CREATION_TIME,
                    Filter: ({filter, onChange}) => {
                        let value = filter && filter.value;
                        if (typeof value === 'string') {
                            value = moment(value).toDate();
                        }
                        return <DatePickerTableComponent
                            value={value || undefined}
                            onChange={onChange}
                            filter={filter}/>;
                    },
                    Cell: e => <FormattedDate value={new Date(e.value)}/>,
                },
                {
                    id: 'ISSUE_ORIGIN',
                    accessor: 'issueOrigin',
                    message: listMessages.TABLE_IT_ISSUE_ORIGIN,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {allIssueOrigins.map((key, index) =>
                                <option key={index} value={key}>
                                    {issueOriginMessages[key] ? intl.formatMessage(issueOriginMessages[key]) : key}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{issueOriginMessages[e.value] ? intl.formatMessage(issueOriginMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'ISSUE_IDENTIFIED',
                    accessor: 'issueIdentified',
                    message: listMessages.TABLE_IT_ISSUE_IDENTIFIED,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {issueIdentifiedMessages.map((key, index) =>
                                <option key={index} value={key}>
                                    {issueIdentifiedIntlMessages[key]
                                        ? intl.formatMessage(issueIdentifiedIntlMessages[key])
                                        : key}
                                </option>
                            )}
                        </select>
                    ),
                    Cell: e => <div>{issueIdentifiedIntlMessages[e.value] ? intl.formatMessage(issueIdentifiedIntlMessages[e.value]) : (e.value || '')}</div>,
                },
                {
                    id: 'PRIORITY',
                    accessor: row => row.priorityTreatment || row.maintenancePriority,
                    message: listMessages.TABLE_IT_PRIORITY,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {priorityTreatment.map((key, index) =>
                                <option key={index} value={key}>
                                    {priorityTreatmentMessages[key] ? intl.formatMessage(priorityTreatmentMessages[key]) : key}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{priorityTreatmentMessages[e.value] ? intl.formatMessage(priorityTreatmentMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'CREATED_BY_IPN',
                    accessor: 'creatorIpn',
                    message: listMessages.TABLE_IT_CREATED_BY_IPN,
                    Cell: e => <div>{e.value}</div>,
                },
                {
                    id: 'STATUS',
                    accessor: 'status',
                    message: listMessages.TABLE_REQUEST_STATUS,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {getInternalTicketFormStates(domain).map((key, index) =>
                                <option key={index} value={key}>
                                    {formStatesMessages[key] ? intl.formatMessage(formStatesMessages[key]) : key}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{formStatesMessages[e.value] ? intl.formatMessage(formStatesMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'DEALER_TICKET_NUMBER',
                    accessor: 'ticketReference',
                    message: listMessages.TABLE_DEALER_TICKET_NUMBER,
                    Cell: row => <Link to={{
                        pathname: `/ase/view/${get(row, 'value.uuid')}`,
                        redirectedFromInternal: true
                    }}>{get(row, 'value.pfxNumber') ? formatTicketNumber(get(row, 'value.pfxNumber'), get(row, 'value.sfxNumber')) : ''}</Link>
                },
                {
                    id: 'SG_REQUESTOR',
                    accessor: 'solutionGroup',
                    message: listMessages.TABLE_SG_REQUESTOR,
                    Cell: e =>
                        <div>{get(e, 'value.name', '')}</div>
                },
                {
                    id: 'ASSIGNED_SG',
                    accessor: 'assignedSolutionGroup',
                    message: listMessages.TABLE_ASSIGNED_SOLUTION_GROUP,
                    Cell: e =>
                        <div>{get(e, 'value.name', '')}</div>
                },
                {
                    id: 'LUP_QS_ASSOCIATED',
                    accessor: 'lupQsAssociated',
                    message: listMessages.TABLE_IT_LUP_QS_ASSOCIATED,
                },
                {
                    id: 'DOCUMENTATION_UPDATE',
                    accessor: 'docUpdateNeeded',
                    message: listMessages.TABLE_IT_DOCUMENTATION_UPDATE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {documentationUpdate.map((key, index) =>
                                <option key={index} value={key}>
                                    {commonMessages[key] ? intl.formatMessage(commonMessages[key]) : key}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{commonMessages[e.value] ? intl.formatMessage(commonMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'LAST_UPDATE',
                    accessor: 'lastUpdate',
                    Filter: ({filter, onChange}) => {
                        let value = filter && filter.value;
                        if (typeof value === 'string') {
                            value = moment(value).toDate();
                        }
                        return <DatePickerTableComponent
                            value={value || undefined}
                            onChange={onChange}
                            filter={filter}/>;
                    },
                    message: listMessages.TABLE_IT_LAST_STATUS_DATE,
                    Cell: e => <FormattedDate value={new Date(e.value)}/>,
                },
                {
                    id: 'LAST_EDITOR',
                    accessor: 'lastEditor',
                    message: listMessages.TABLE_IT_LAST_EDITOR,
                }
            ]
        };
    }

    componentWillUnmount() {
        this.props.resetRedirectAfterAseInternalLockTicket();
    }

    handleEditClick = ({id}) => {
        //mozna nacitat info do listu a delat lokalni kontrolu jestli je ticket zamceny
        if (!this.props.lockTicket.isTicketLocking) {
            this.props.lockAseInternalTicket(id);
            this.setState({ratchet: true});
        }
    };

    selectMultipleOption = (value) => {
        this.props.updateAseUserInternalTicketListPreference(this.props.loggedUser.ipn, this.state.columnLibrary.filter(item => !value.some(value => value.id === item.id)).map(column => column.id))
    };

    render() {
        const {intl, asePreferences, lockTicket, location, aseInternalTicketListData} = this.props;
        const {columnLibrary} = this.state;
        if (lockTicket.redirect && this.state.ratchet) {
            // Find the ticket in the list data to check its formType
            const ticket = aseInternalTicketListData.listData.find(t => t.id === lockTicket.uuid);
            const formTypeToPathMap = {
                [ASE_INTERNAL_TICKET_FORM]: ASE_INTERNAL_TICKET,
                [ASE_INTERNAL_MAINTENANCE_TICKET_FORM]: ASE_INTERNAL_MAINTENANCE_TICKET,
                [ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM]: ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET,
            };

            const editPath = `${formTypeToPathMap[ticket.formType] || ASE_INTERNAL_TICKET}/edit/${lockTicket.uuid}`;
            this.props.history.push(editPath);
        }
        if (asePreferences.isLoading) {
            return <Loader/>;
        }
        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage {...listMessages.INTERNAL_TICKET_TITLE}/>}/>
                <div className="d-flex justify-content-end mb-3">
                    <div className="col-xl-4 col-lg-7 col-md-9 col-sm-12">
                        <span
                            className="font-weight-bold"><FormattedMessage {...listMessages.VISIBLE_COLUMNS}/>{':'}</span>
                        <StyledPicky
                            value={columnLibrary.filter(item => !get(asePreferences, 'menuInternalList', {default: []}).includes(item.id)).map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            options={columnLibrary.map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            onChange={this.selectMultipleOption}
                            open={false}
                            valueKey="id"
                            labelKey="message"
                            multiple={true}
                            includeSelectAll={true}
                            selectAllText={<FormattedMessage {...commonMessages.SELECT_ALL}/>}
                            manySelectedPlaceholder={'%s ' + intl.formatMessage(commonMessages.SELECTED)}
                            allSelectedPlaceholder={'%s ' + intl.formatMessage(commonMessages.SELECTED)}
                            includeFilter={false}
                            dropdownHeight={600}
                        />
                    </div>
                </div>
                <ListAseInternalTicketTable
                    columns={columnLibrary.filter(item => !get(asePreferences, 'menuInternalList', {default: []}).includes(item.id))}
                    handleEditClick={this.handleEditClick}
                    location={location}
                />
            </div>
        );
    }
}

ListAseInternalTicketPage.propTypes = {
    lockTicket: PropTypes.object.isRequired,
    clearAlerts: PropTypes.func.isRequired,
    updateAseUserInternalTicketListPreference: PropTypes.func.isRequired,
    lockAseInternalTicket: PropTypes.func.isRequired,
    resetRedirectAfterAseInternalLockTicket: PropTypes.func.isRequired,
    loggedUser: PropTypes.object.isRequired,
    intl: PropTypes.any.isRequired,
    asePreferences: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    aseInternalTicketListData: PropTypes.object.isRequired,
};


const mapStateToProps = state => ({
    loggedUser: state.profile.userDetail,
    asePreferences: state.asePreferences,
    lockTicket: state.aseInternalTicketListOrderLockTicketCheck,
    aseInternalTicketListData: state.aseInternalTicketListPage
});

export default checkRoles(withRouter(connect(mapStateToProps, {
    clearAlerts,
    updateAseUserInternalTicketListPreference,
    lockAseInternalTicket,
    resetRedirectAfterAseInternalLockTicket,
})(injectIntl(ListAseInternalTicketPage))), ['AS_SG_EDITOR']);
